import {useMutation, useQuery} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateAddressInfo,
    getListGenericAddress,
} from '../AddressEndPoint'

export const useCountries = requestorId => {
    const {addressKeys} = QueryKeyManager(QueryKeyTypes.address, requestorId)

    const countryPath = 'address/getCountries'

    return useQuery({
        queryKey: addressKeys.country(),
        queryFn: () => getListGenericAddress(countryPath, requestorId),
        enabled: !!requestorId,
    })
}

export const useStates = (requestorId, refCountry) => {
    const {addressKeys} = QueryKeyManager(QueryKeyTypes.address, requestorId)

    const statePath = 'address/getStates'

    return useQuery({
        queryKey: addressKeys.states({countryCode: refCountry}),
        queryFn: () =>
            getListGenericAddress(statePath, requestorId, refCountry),
        enabled: !!requestorId && !!refCountry,
    })
}

export const useCities = (requestorId, refCountry, refState) => {
    const {addressKeys} = QueryKeyManager(QueryKeyTypes.address, requestorId)

    const cityPath = 'address/getCities'

    return useQuery({
        queryKey: addressKeys.cities({
            countryCode: refCountry,
            stateCode: refState,
        }),
        queryFn: () =>
            getListGenericAddress(cityPath, requestorId, refCountry, refState),
        enabled: !!requestorId && !!refCountry && !!refState,
    })
}

export const useAddressInformationCRUD = (type, requestorId) => {
    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateAddressInfo(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Address Information Update Successfully !!',
                    )
                }
            }
        },
    })
}
